// extracted by mini-css-extract-plugin
export default {"modal":"style_modal__AoSnN","modal__title":"style_modal__title__Z+x6Q","modal__btnContainer":"style_modal__btnContainer__4nA0z"};